// const ip = 'http://10.10.10.48';

// const ipLogin = 'http://10.10.10.48';

const ip = 'http://192.168.14.209';

const ipLogin = 'http://192.168.14.209';

export { ip, ipLogin };
